import { faPlus, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCallback, useEffect, useMemo, useState } from 'react';
import InfoModal from '../../../shared/components/InfoModal';
import DescuentosMasivosForm from './components/DescuentosMasivosForm';
import { toast } from 'react-toastify';
import { setErrorMessage } from '../../../shared/helpers/functionalities';
import { API_DESCUENTOS_MASIVOS } from '../../../shared/services/descuentosMasivos';
import { useDispatch, useSelector } from 'react-redux';
import './descuentosMasivos.scss';
import ActionsMenu from '../../../shared/components/ActionsMenu';
import { getActions } from './actions';
import EmailPruebaForm from './components/EmailPruebaForm';
import EmailClientesForm from './components/EmailClientesForm';

const DescuentosMasivos = () => {
    const [search, setSearch] = useState('');
    const [allDiscounts, setAllDiscounts] = useState([]);
    const [currentDiscount, setCurrentDiscount] = useState(null);
    const [openForm, setOpenForm] = useState(false);
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loading);

    const filteredDiscounts = useMemo(() => {
        return allDiscounts.filter(
            (discount) =>
                !search ||
                discount.codigo?.toLowerCase().includes(search.toLowerCase())
        );
    }, [allDiscounts, search]);

    const handleAction = (action, discount) => {
        handleOpenForm(action, discount); 
    }

    const handleSearch = (e) => {
        setSearch(e.target.value.toLowerCase());
    };

    const sortByCaducidad = (discounts) =>
        discounts.sort((a, b) => new Date(b.caducidad) - new Date(a.caducidad));

    const updateList = (list, data) =>
        sortByCaducidad(
            list.map((discount) => (discount.id === data.id ? data : discount))
        );

    const handleOpenForm = (action = 'edit', discount = null) => {
        setCurrentDiscount(discount?.id ? discount : null);
        setOpenForm(action);
    };

    const handleCloseForm = () => {
        setCurrentDiscount(null);
        setOpenForm(false);
    };

    const createDiscount = async (data) => {
        try {
            const res = await API_DESCUENTOS_MASIVOS.newDiscount(data);
            if (res?.success) {
                setAllDiscounts(sortByCaducidad([res.data, ...allDiscounts]));
                toast.success('Descuento creado.')
            }
        } catch (error) {
            toast.error(setErrorMessage(error));
        }
    };

    const updateDiscount = async (data) => {
        try {
            const res = await API_DESCUENTOS_MASIVOS.updateDiscount(data);
            if (res?.success) {
                setAllDiscounts(updateList(allDiscounts, data));
                toast.success('Descuento actualizado.');
            }
        } catch (error) {
            toast.error(setErrorMessage(error));
        }
    };
    
    const getAllDiscounts = useCallback(async () => {
        try {
            dispatch({ type: 'loading/set', payload: true });
            const res = await API_DESCUENTOS_MASIVOS.getDiscounts();
            if (res?.success) {
                setAllDiscounts(res.data);
            }
        } catch (error) {
            toast.error(setErrorMessage(error));
        } finally {
            dispatch({ type: 'loading/set', payload: false });
        }
    }, [dispatch]);

    useEffect(() => {
        getAllDiscounts();
    }, [getAllDiscounts]);

    return (
        <div className="w-100 d-flex flex-column align-items-start">
            <div className="w-100 d-flex justify-content-center">
                <div className="col-12 col-md-8 d-flex flex-column align-items-center order-1 order-md-0">
                    <div className="w-100 d-flex align-content-center justify-content-between mb-4">
                        <div className="flex-grow-1 d-flex align-items-center ">
                            <div className="position-relative w-50">
                                <input
                                    type="text"
                                    name="searcher"
                                    className="form-control"
                                    value={search}
                                    placeholder="Busca por código de descuento"
                                    onChange={(e) => handleSearch(e)}
                                />
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    color="#215732"
                                    className="icon"
                                />
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn btn-add"
                            onClick={() => handleOpenForm()}
                        >
                            <span className="add">
                                <FontAwesomeIcon
                                    icon={faPlus}
                                    size="1x"
                                    className="action"
                                    color="#215732"
                                />
                            </span>
                            Nuevo
                        </button>
                    </div>

                    <div className="w-100 table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className="text-center">Código</th>
                                    <th className="text-center">Descuento</th>
                                    <th className="text-center">Importe máximo</th>
                                    <th className="text-center">Caducidad</th>
                                    <th className="text-center">
                                        Uso limitado
                                    </th>
                                    <th className="text-center">Enviado</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredDiscounts?.map((discount) => {
                                    return (
                                        <tr key={discount.id}>
                                            <td className="text-center">
                                                <span>{discount.codigo}</span>
                                            </td>
                                            <td className="text-center">
                                                {discount.descuento}%
                                            </td>
                                            <td className="text-center">
                                                {discount.importe_maximo || '-'}
                                            </td>
                                            <td
                                                className={`text-center ${
                                                    new Date(
                                                        discount.caducidad
                                                    ) < new Date()
                                                        ? 'text-danger'
                                                        : ''
                                                }`}
                                            >
                                                {discount.caducidad || '-'}
                                            </td>

                                            <td className="text-center">
                                                {discount.uso_limitado
                                                    ? 'SÍ'
                                                    : 'NO'}
                                            </td>
                                            <td className="text-center">
                                                {discount.enviado_a?.length > 0
                                                    ? <span className="text-green fw-bold">{discount.enviado_a.join(', ')}</span>
                                                    : '-'
                                                }
                                            </td>
                                            <td className="text-center">
                                                <ActionsMenu
                                                    options={getActions(discount?.subject && discount?.texto, discount?.enviado_a)}
                                                    onAction={(action) => handleAction(action, discount)}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        {filteredDiscounts?.length === 0 && !loading && (
                            <p
                                className="text-center p-3"
                                style={{ background: '#F5F5F7' }}
                            >
                                No hay descuentos
                            </p>
                        )}
                    </div>
                </div>

                {openForm === 'edit' && (
                    <InfoModal
                        state={openForm === 'edit'}
                        title={
                            (currentDiscount ? 'Editar' : 'Nuevo') +
                            ' descuento'
                        }
                        content={
                            <DescuentosMasivosForm
                                discount={currentDiscount}
                                updateDiscount={updateDiscount}
                                createDiscount={createDiscount}
                                handleCancel={handleCloseForm}
                            />
                        }
                        width={'md'}
                        onClose={handleCloseForm}
                    />
                )}
                
                {openForm === 'email-test' && (
                    <InfoModal
                        state={openForm === 'email-test'}
                        title='Enviar email de prueba'
                        content={
                            <EmailPruebaForm
                                discount_id={currentDiscount.id}
                                handleCancel={handleCloseForm}
                            />
                        }
                        width={'sm'}
                        onClose={handleCloseForm}
                    />
                )}
                
                {openForm === 'email' && (
                    <InfoModal
                        state={openForm === 'email'}
                        title='Enviar email a los clientes'
                        content={
                            <EmailClientesForm
                                discount_id={currentDiscount.id}
                                enviadoA={currentDiscount.enviado_a || []}
                                handleCancel={handleCloseForm}
                            />
                        }
                        width={'sm'}
                        onClose={handleCloseForm}
                    />
                )}
                
            </div>
        </div>
    );
};

export default DescuentosMasivos;
